import React from 'react';
import { Box } from '@chakra-ui/react';
import { Typography } from 'components/v2/typography/typography';
import { Swiper, SwiperSlide } from 'swiper/react';
import 'swiper/css';
import 'swiper/css/pagination';
import 'swiper/css/navigation';
import { Button } from '../button/button';
import { ArrowRightIcon } from 'components/icons';
import { TestimonialCard } from './testimonial-card';
import { Pagination, Navigation, Autoplay } from 'swiper/modules';
import bannerBackground from '../../../assets/photos/banner_background.png';
import kadrenAvatar from '../../../assets/photos/image-kadren.png';
import karlieAvatar from '../../../assets/photos/image-karlie.png';
import soleilleAvatar from '../../../assets/photos/image-soleille.png';

// Constants for reuse
const TESTIMONIALS = [
  {
    name: 'Kadren',
    username: 'KADRENNNN',
    text: "I've never had such an in depth analysis/ strategic plan like this EVERY!",
    avatarSrc: kadrenAvatar,
  },
  {
    name: 'Karlie Cupani',
    username: 'KARLIECUPANI',
    text: "I'm truly impressed with how much it analyzed and how thorough it was.",
    avatarSrc: karlieAvatar,
  },
  {
    name: 'Soleille',
    username: 'BONJOURSOLEILLE',
    text: "I can't be thankful enough for the time, detail, and creativity that went into this.",
    avatarSrc: soleilleAvatar,
  },
];

// Common Swiper configuration
const SWIPER_CONFIG = {
  loop: true,
  pagination: false,
  autoplay: {
    delay: 5000,
    disableOnInteraction: false,
  },
  navigation: false,
  modules: [Pagination, Navigation, Autoplay],
  spaceBetween: 8,
};

// Breakpoints for desktop carousel
const DESKTOP_BREAKPOINTS = {
  768: {
    slidesPerView: 1,
    spaceBetween: 8,
  },
  992: {
    slidesPerView: 3,
    spaceBetween: 8,
  },
};

/**
 * Hero component that displays a banner with a title, CTA button, and testimonial cards
 * Responsive design for mobile, tablet, and desktop views
 */
export function Hero() {
  // Render testimonial slides
  const renderTestimonialSlides = (isMobile = false) => {
    return TESTIMONIALS.map((testimonial, index) => (
      <SwiperSlide key={`testimonial-${testimonial.username}-${index}`}>
        <Box width="100%" mx="auto">
          <TestimonialCard
            name={testimonial.name}
            username={testimonial.username}
            text={testimonial.text}
            avatarSrc={testimonial.avatarSrc}
          />
        </Box>
      </SwiperSlide>
    ));
  };

  return (
    // Main Hero Container
    <Box
      width="100%"
      height={{ base: '262px', md: 'auto', lg: '166px' }}
      minHeight={{ base: '262px', md: '166px' }}
      mx="auto"
      py={{ base: 4, md: 6, lg: 0 }}
      borderRadius="16px"
      backgroundImage={`url(${bannerBackground})`}
      backgroundSize="cover"
      backgroundPosition="center"
      backgroundRepeat="no-repeat"
      display={{ base: 'block', md: 'flex', lg: 'block' }}
      flexDirection={{ base: 'column', md: 'row', lg: 'initial' }}
      justifyContent={{ base: 'space-around', md: 'space-around', lg: 'initial' }}
      alignItems={{ base: 'center', md: 'stretch', lg: 'initial' }}
      px={{ base: 3, sm: 4, md: 6, lg: 0 }}
      position="relative"
      overflow="hidden">
      {/* Text Content Section: Title and Call to Action Button */}
      <Box
        position={{ base: 'absolute', lg: 'absolute' }}
        top={{ base: '25px', lg: '42px' }}
        left={{ base: '32px', lg: '20px' }}
        width={{ base: '80%', lg: '274px' }}
        maxWidth={{ base: '300px', md: '300px' }}
        mr={{ md: 4, lg: 0 }}
        mb={{ base: 6, md: 0, lg: 0 }}
        textAlign={{ base: 'left', md: 'left' }}
        display="flex"
        flexDir="column"
        alignItems="flex-start"
        gap={{ base: 3, md: 3, lg: '17px' }}>
        <Typography
          variant="hero-title"
          color="#F2EEE4"
          width="100%"
          height="46px"
          maxWidth="274px"
          lineHeight={{ base: '1.2', md: '1.3' }}>
          Need a Rollout Strategy? We'll make one for you.
        </Typography>
        <a href="https://zthwflczjj2.typeform.com/to/WbDtSF0P" style={{ textDecoration: 'none' }}>
          <Button variant="link" endIcon={<ArrowRightIcon />} width="auto" height="16px" gap="8px">
            <Typography variant="button-text" color="#FF335F">
              Get Your Personalized Rollout
            </Typography>
          </Button>
        </a>
      </Box>

      {/* Mobile Testimonial Carousel - Only visible on mobile */}
      <Box
        display={{ base: 'block', md: 'none' }}
        position="absolute"
        bottom="20px"
        left="32px"
        right="32px"
        width="calc(100% - 64px)"
        maxWidth="100%"
        height="auto">
        <Swiper {...SWIPER_CONFIG} slidesPerView={1} className="mobileSwiper">
          {renderTestimonialSlides(true)}
        </Swiper>
      </Box>

      {/* Desktop Carousel Section: Testimonial Cards */}
      <Box
        display={{ base: 'none', md: 'block' }}
        flex={{ base: '1 1 100%', md: '1 1 0px', lg: 'none' }}
        width={{ base: '100%', lg: '768px' }}
        height="117px"
        minWidth={{ base: '0', md: '0', lg: 'auto' }}
        overflow="hidden"
        position={{ base: 'absolute', md: 'absolute', lg: 'absolute' }}
        top={{ base: 'auto', md: '25px', lg: '25px' }}
        left={{ base: 'auto', md: '305px', lg: '297px' }}>
        <Swiper {...SWIPER_CONFIG} slidesPerView={1} breakpoints={DESKTOP_BREAKPOINTS} className="desktopSwiper">
          {renderTestimonialSlides()}
        </Swiper>
      </Box>
    </Box>
  );
}
